import { FlexProps, Flex } from '@chakra-ui/react';

const ProductFieldColumnTitle = (props: FlexProps) => (
  <Flex
    sx={{
      flex: 1,
      justifyContent: 'flex-start',
      textTransform: 'uppercase',
      my: 1.5,
    }}
    {...props}
  />
);

export default ProductFieldColumnTitle;
